import { RECORD_EXPERIMENT_ID_VIEWED } from 'redux/modules/experiments/actions/types';

const monetateViewed = 'monetate_fe_experiment_viewed';

export const trackExperiment =
  event =>
  (state, { id, variant } = {}) => {
    const impression = state.experiments.impressions[id];

    return {
      event,
      monetate_fe_experiment: {
        id: `fe_${id}`,
        variant: variant === 'default' ? 'Control' : variant,
        experience_type: impression?.experience_type,
        experience_id: impression?.experience_id,
        experience_name: impression?.experience_name,
        experience_label: impression?.experience_label,
        variant_label: impression?.variant_label,
        control_allocation: impression?.control_allocation,
      },
    };
  };

export default {
  [RECORD_EXPERIMENT_ID_VIEWED]: trackExperiment(monetateViewed),
};
